import React, { useState, createContext, useContext } from "react";
import { useAuth } from "../../hooks";
import { getNarratorsAnalytics, getCreatorsAnalytics } from "../../firebase";

export const DashboardContext = createContext();
export const useDashboardContext = () => useContext(DashboardContext);

export const DashboardProvider = ({ children }) => {
  const { currentUser } = useAuth();

  const [loading, setLoading] = useState(false);
  const [narratorAnalytics, setNarratorAnalytics] = useState({
    monthlyData: [],
    grandTotals: { users: 0, nonUsers: 0, total: 0 }
  });
  const [creatorAnalytics, setCreatorAnalytics] = useState({
    monthlyData: [],
    grandTotal: 0
  });

  const handleGetNarratorsAnalytics = async () => {
    try {
      setLoading(true);
      console.log('Fetching narrator analytics...');
      
      const result = await getNarratorsAnalytics();
      console.log('Narrator analytics result:', result.data);
      
      setNarratorAnalytics(result.data);
    } catch (error) {
      console.error('Error getting narrator analytics:', error);
      // Set empty data on error
      setNarratorAnalytics({
        monthlyData: [],
        grandTotals: { users: 0, nonUsers: 0, total: 0 }
      });
    } finally {
      setLoading(false);
    }
  };

  const handleGetCreatorsAnalytics = async () => {
    try {
      setLoading(true);
      console.log('Fetching creator analytics...');
      
      const result = await getCreatorsAnalytics();
      console.log('Creator analytics result:', result.data);
      
      setCreatorAnalytics(result.data);
    } catch (error) {
      console.error('Error getting creator analytics:', error);
      // Set empty data on error
      setCreatorAnalytics({
        monthlyData: [],
        grandTotal: 0
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardContext.Provider
      value={{
        handleGetNarratorsAnalytics,
        narratorAnalytics,
        setNarratorAnalytics,
        handleGetCreatorsAnalytics,
        creatorAnalytics,
        setCreatorAnalytics,
        loading,
        setLoading,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};
